import { TPhoneCaseFormValues } from './PhoneCaseForm.types';

export const PHONE_CASE_FORM_DEFAULT_VALUES: TPhoneCaseFormValues = {
  name: '',
  description: '',
  price: 0,
  newPrice: 0,
  tags: [],
  customFields: [],
};
